import CC_blocks from './Blocks/VeganShake'
export default {
    "id": 7, "name": "Vegan Shake",
    "state": 1,
    "image": "/media/images/pages/8.png",
    "blocks": CC_blocks
}